<template>
  <ui-avatar
    :size="size"
    :lazy="false"
    :url="url"
    :username="username"
  ></ui-avatar>
</template>
<script>
export default {
  name: "avatar",
  props: ["size", "url", "username"]
};
</script>
